import {
  Component,
  OnInit,
  ViewContainerRef,
  HostListener,
  EventEmitter,
  OnDestroy,
  Inject,
  PLATFORM_ID,
  ElementRef,
} from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
//import {ConstantMessages} from '../common/ConstantMessages';
import { ToastrService } from 'ngx-toastr';
//import { Cookie } from 'ng2-cookies/ng2-cookies';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { forkJoin, Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { isPlatformServer } from '@angular/common';
import { ConstantMessages } from 'src/app/common/ConstantMessages';
import { Constants } from 'src/app/common/Constants';
import { MessageService } from 'src/app/common/message.service';
import { SeoService } from 'src/app/seo.service';
import { HTTPService } from 'src/app/services/http.service';
import { SharedService } from 'src/app/services/shared.service';
import { windowScreen } from 'src/app/services/utility.service';
import { LoginComponent } from 'src/app/shared/components/Login/Login.component';
import { toLower } from 'lodash';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-master-category',
  templateUrl: './master-category.component.html',
  styleUrls: ['./master-category.component.scss'],
  providers: [HTTPService, MessageService],
})
export class MasterCategoryComponent {
  public constants: Constants;
  public constantMessages: ConstantMessages;
  public pageSize: any = 0;
  public messageType: any;
  public screen: string = 'mobile';
  public VideoFilterModel = {
    videoId: 0,
    categoryId: 0,
    SubcategoryId: 0,
    StartRow: 0,
    PageSize: 1000,
    ScreenType: 1,
    IsMainHomePageRequest: false,
  };
  AllVideoData: any = [];
  public CategoryData: any;
  public pageTitle: string = '';
  public isAllVideoLoading: boolean = false;
  public isShowLoader: boolean = true;
  public isShowNoContent: boolean = false;
  public isAllVideoLoaded: boolean = false;
  public categoryName: string;
  public subCategoryName: string;
  assetURL = environment.assetURL;
  //AllVideoData = this.homedata1.homepageData;
  subscription = new Subscription();
  subCategoryData: any;
  categoryData: any;
  categoryBackgroundImage: any;
  public categoryHeadName: string;
  public isDataAvailable = false;
  public randomVideoLink: any;
  constructor(
    private dialog: MatDialog,
    private _httpService: HTTPService,
    private _router: Router,
    private _route: ActivatedRoute,
    private messageService: MessageService,
    public toastr: ToastrService,
    vcr: ViewContainerRef,
    private sharedService: SharedService,
    private seoService: SeoService,
    private elementRef: ElementRef,
    public sanitizer: DomSanitizer,
    @Inject(PLATFORM_ID) private platformId
  ) {
    this.constants = new Constants();
    this.constantMessages = new ConstantMessages();
    this.messageType = this.constants.messageType;
    if (!isPlatformServer(this.platformId))
      window.addEventListener('resize', this.handleWindowResize);
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  ngOnInit() {
    this.subscription.add(
      this._route.paramMap.subscribe((params) => {
        this.AllVideoData = [];
        this.VideoFilterModel.StartRow = 0;
        this.isAllVideoLoading = false;
        this.isAllVideoLoaded = false;
        this.categoryName = params.get('category');
        this.subCategoryName = params.get('subCategory');
        if (this.subCategoryName == null)
          this.subCategoryName = this.categoryName;
        if (this.sharedService.videoCategoryData != undefined) {
          this.updateCategoryData();
        } else {
          this.sharedService.isVideoCategoryDataAvailable.subscribe(
            (data: any) => {
              if (data) {
                this.updateCategoryData();
              }
            }
          );
        }
      })
    );
    if (!isPlatformServer(this.platformId)) this.handleWindowResize();
  }
  updateCategoryData() {
    this.sharedService.videoCategoryData.forEach((category) => {
      if (
        toLower(this.categoryName).indexOf(toLower(category.CategoryDesc)) !=
        -1 ||
        toLower(category.CategoryDesc).indexOf(toLower(this.categoryName)) != -1
      ) {
        this.VideoFilterModel.categoryId = category.CategoryId;
        this.VideoFilterModel.SubcategoryId = 0;
        this.categoryBackgroundImage = category.CategoryId == 1 ? "wedding-bg.jpg" :
          category.CategoryId == 2 ? "birthday-bg.jpg" :
            category.CategoryId == 3 ? "greetings-bg.jpg" :
              category.CategoryId == 4 ? "baby-kids-bg.jpg" :
                category.CategoryId == 6 ? "house-warming-bg.jpg" : "greetings-bg.jpg";
        this.categoryHeadName = category.CategoryId == 1 ? "Wedding" :
          category.CategoryId == 2 ? "Birthday" :
            category.CategoryId == 3 ? "Greetings" :
              category.CategoryId == 4 ? "Baby & kids" :
                category.CategoryId == 6 ? "House Warming" : "Greetings";
      }
      this.GetCategoryWiseVideoDataList();
    });

    this.CategoryData = this.sharedService.videoCategoryData;
    var categroydata = this.CategoryData.filter(
      (x) => x.CategoryId == this.VideoFilterModel.categoryId
    )[0];
    this.subCategoryData = categroydata?.SubCategoryData;
    this.pageTitle = '';
    if (categroydata != null && categroydata != undefined && categroydata != '') {
      this.pageTitle =
        'Customizable Invitations for ' + categroydata.CategoryDesc;
    }
  }
  getVideoData(subCategoryId: number) {
    return this.AllVideoData.filter((x) => x.SubCategoryId == subCategoryId);
  }
  ngAfterViewInit(): void {
    let seoTags = this.sharedService.getSeoTags(
      true,
      this.VideoFilterModel.categoryId,
      this.VideoFilterModel.SubcategoryId,
      this.categoryName,
      this.subCategoryName
    );
    this.seoService.generateTags({
      title: seoTags.metaTitle,
      description: seoTags.metaDescription,
      image: `${this.assetURL}/assets/images/logo.png`,
      keywords: seoTags.metaKeywords,
    });
  }

  handleWindowResize = (): void => {
    this.screen = windowScreen();
  };

  public GetCategoryDataList() {
    this.subscription.add(
      this._httpService
        .ajaxPost('homepage/GetCategoryData', { pCategoryId: '0' })
        .subscribe(
          (data) => {
            if (data['Message'].MessageTypeValue == this.messageType.Success) {
            } else if (data['Message'].MessageTypeValue == 6) {
              this.isAllVideoLoaded = true;
            } else {
              this.messageService.showMessage(
                data['Message'].Text,
                data['Message'].MessageTypeValue
              );
            }
          },
          (error: any) => {
            // this.hideSpinner();
            // this.messageService.showMessage(this.constErrors.CommonError, this.messageType.Error);
          }
        )
    );
  }

  public GetCategoryWiseVideoDataList() {
    if (this.isAllVideoLoading) return false;
    this.isAllVideoLoading = true;
    let categoryData = this._httpService.ajaxPost(`Category/GetCategoryDataWithDescription/${this.VideoFilterModel.categoryId}`, null);
    let homePageData = this._httpService.ajaxPost('homepage/GetHomepageData', this.VideoFilterModel);
    forkJoin([categoryData, homePageData]).subscribe(results => {
      this.processHomePageData(results[1]);
      this.GetCategoryDescription(results[0]);
      this.sharedService.isShowLoader.next(false);
    });
  }
  public GetCategoryDescription(data) {
    this.categoryData = data.filter(x => x.CategoryId == this.VideoFilterModel.categoryId)[0];
  }
  scrollToElement(elementId: string): void {
    const element = this.elementRef.nativeElement.querySelector(`#section${elementId}`);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }
  processHomePageData(data) {
    if (data['Message'].MessageTypeValue == this.messageType.Success) {
      var allVideoData = data['AllVideoData'];
      if (allVideoData != null && allVideoData.length > 0) {
        allVideoData.forEach((element) => {
          this.AllVideoData.push(element);
        });
        this.randomVideoLink = this.sanitizer.bypassSecurityTrustResourceUrl(this.AllVideoData[Math.floor(Math.random() * this.AllVideoData.length)]?.VideoLink);
      } else {
        this.isShowNoContent = true;
      }
      this.isShowLoader = false;
    } else if (data['Message'].MessageTypeValue == 6) {
      this.isAllVideoLoaded = true;
      this.isShowLoader = false;
      this.isShowNoContent = true;
    } else {
      this.messageService.showMessage(
        data['Message'].Text,
        data['Message'].MessageTypeValue
      );
      this.isShowLoader = false;
    }
    this.isAllVideoLoading = false;
  }

  openDialog(): void {
    this.dialog.open(LoginComponent);
  }

  public openVideoPage(item) {
    let encryptedqueryparams: { videoId: any };
    encryptedqueryparams = {
      videoId: item?.VideoId,
    };
    this._router.navigate([
      `/${item.NameEnglish.replace(
        / +/g,
        '-'
      )}/video/${this.sharedService.encryptData(
        JSON.stringify(encryptedqueryparams)
      )}`,
    ]);
  }

  getCssClass(category: string): string {
    switch (category) {
      case 'Category 1':
        return 'cat-bg-1'; // CSS class for Category 1
      case 'Category 2':
        return 'category-2'; // CSS class for Category 2
      case 'Category 3':
        return 'category-3'; // CSS class for Category 3
      case 'Category 4':
        return 'category-4'; // CSS class for Category 4
      default:
        return ''; // default CSS class
    }
  }
  changeContentVisibility(category: any) {
    category.IsShowMore = !category.IsShowMore;
  }
}
